import React, { useEffect, useState } from 'react';

import Card from '../../../../components/bootstrap/Card';
import Icon from '../../../../components/icon/Icon';



const HeaderOrder = ({ selectedCard }) => {
	const [timeLeft, setTimeLeft] = useState();

	const mountLabelTitle = () => {
		return <div
			style={{
				display: 'flex',
				gap: '8px',
				alignItems: 'center',
				height: 40,
				backgroundColor: selectedCard.disputeStatus === 'HSD' ? '#F3542155' : '#46bcaa',
				borderRadius: '12px',
				padding: '10px',
				minWidth: 'max-content'
			}}>
			<Icon style={{ color: selectedCard.disputeStatus === 'HSD' ? '#F35421' : '#ffffff' }} icon='record-circle' />
			<span
				style={{
					color: selectedCard.disputeStatus === 'HSD' ? '#F35421' : '#ffffff',
					fontSize: '1.3rem',
				}}>
				{selectedCard.disputeStatus === 'HSD'
					? 'Aberto: ' : selectedCard.disputeStatus === 'HSS'
						? 'Finalizado: '
						: ''}

			</span>
			<span
				style={{
					fontSize: '1.2rem',
					color: selectedCard.disputeStatus === 'HSD' ? '#F35421' : '#ffffff',
				}}>
				{selectedCard.disputeData?.action}
			</span>

		</div>
	}

	useEffect(() => {
		if (!selectedCard?.disputeData?.expiresAt?.seconds) return;

		const expiresAt = selectedCard.disputeData.expiresAt.seconds * 1000;

		const updateTimer = () => {
			const now = Date.now();
			const diff = expiresAt - now;

			if (selectedCard.disputeStatus === "HSS") {
				setTimeLeft("Pedido Respondido");
				return;
			}
			if (diff <= 0) {
				setTimeLeft("Tempo de Resposta Expirado");
				return;
			}

			const seconds = Math.floor(diff / 1000);
			const minutes = Math.floor((seconds) / 60);
			const remainingSeconds = seconds % 60;

			setTimeLeft(`${minutes}m ${remainingSeconds}s`);
		};

		updateTimer();

		const interval = setInterval(updateTimer, 1000);

		return () => clearInterval(interval);
	}, [selectedCard?.disputeData?.expiresAt?.seconds]);

	return (
		
		<Card >
			
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					padding: 10,
					alignItems: 'center'
				}}>
				<div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							gap: '10px',
						}}>
						<div className='d-flex'>
							<h5 style={{marginRight: 10}}>
								Nº{' '}
								<strong>
									{selectedCard.orderNumber}
								</strong>
							</h5>
							<p>
								{selectedCard?.disputeData?.createdAt
									? new Date(
										selectedCard?.disputeData?.createdAt.seconds * 1000,
									).toLocaleString()
									: '-'}
							</p>
						</div>
					</div>
					<p>
						{timeLeft === "Tempo de Resposta Expirado" || timeLeft === "Pedido Respondido" ?
							<>
								<strong>{timeLeft}</strong>
							</>
							:
							<>
								Você tem <strong>{` ${timeLeft} `}</strong>
								para responder. Caso não responda,
								<strong>{` ${selectedCard?.disputeData?.timeoutAction}`}</strong>
							</>
						}
					</p>
				</div>
				{mountLabelTitle()}
			</div>
		</Card>
	)
}
export default HeaderOrder